// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type GetSemiConfigDropDownListQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.DropDownListInput>;
}>;


export type GetSemiConfigDropDownListQuery = { __typename?: 'Query', getSemiConfigDropDownList: { __typename?: 'SemiConfigSpecifications', physicalMaterial?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, scale?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, modification?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, purification?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, format?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, species?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, structure?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string, enabled: boolean }> | null, amount?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, vector?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, titer?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, volume?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, aliquot?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, lentivirusBackbone?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null, companionProducts?: Array<{ __typename?: 'SemiConfigSpecificationsItem', key: string, value: string }> | null } };


export const GetSemiConfigDropDownListDocument = gql`
    query getSemiConfigDropDownList($input: DropDownListInput) {
  getSemiConfigDropDownList(input: $input) {
    physicalMaterial {
      key
      value
    }
    scale {
      key
      value
      enabled
    }
    modification {
      key
      value
      enabled
    }
    purification {
      key
      value
      enabled
    }
    format {
      key
      value
      enabled
    }
    species {
      key
      value
      enabled
    }
    structure {
      key
      value
      enabled
    }
    amount {
      key
      value
    }
    vector {
      key
      value
    }
    titer {
      key
      value
    }
    volume {
      key
      value
    }
    aliquot {
      key
      value
    }
    lentivirusBackbone {
      key
      value
    }
    companionProducts {
      key
      value
    }
  }
}
    `;
export type GetSemiConfigDropDownListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>, 'query'>;

    export const GetSemiConfigDropDownListComponent = (props: GetSemiConfigDropDownListComponentProps) => (
      <ApolloReactComponents.Query<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables> query={GetSemiConfigDropDownListDocument} {...props} />
    );
    

/**
 * __useGetSemiConfigDropDownListQuery__
 *
 * To run a query within a React component, call `useGetSemiConfigDropDownListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSemiConfigDropDownListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSemiConfigDropDownListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSemiConfigDropDownListQuery(baseOptions?: Apollo.QueryHookOptions<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>(GetSemiConfigDropDownListDocument, options);
      }
export function useGetSemiConfigDropDownListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>(GetSemiConfigDropDownListDocument, options);
        }
export function useGetSemiConfigDropDownListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>(GetSemiConfigDropDownListDocument, options);
        }
export type GetSemiConfigDropDownListQueryHookResult = ReturnType<typeof useGetSemiConfigDropDownListQuery>;
export type GetSemiConfigDropDownListLazyQueryHookResult = ReturnType<typeof useGetSemiConfigDropDownListLazyQuery>;
export type GetSemiConfigDropDownListSuspenseQueryHookResult = ReturnType<typeof useGetSemiConfigDropDownListSuspenseQuery>;
export type GetSemiConfigDropDownListQueryResult = Apollo.QueryResult<GetSemiConfigDropDownListQuery, GetSemiConfigDropDownListQueryVariables>;